import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { GodinaRacunaDropdownService } from '@kodit/core/services';
import { LoaderService } from 'libs/core/shared-ui/src/lib/loader/loader.service';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GlobalFilterInterceptorService implements HttpInterceptor {
  constructor(
    private _godinaService: GodinaRacunaDropdownService,
    private _loaderService: LoaderService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    req = this._godinaService.applyHeaderFilter(req);
    return next.handle(req).pipe(
      finalize(() => {
        this._loaderService.setShowLoader = false;
      })
    );
  }
}
